const keys = {
  all: ['requirement-templates'],
  companyFolders: companyId => [...keys.all, { companyId: parseInt(companyId, 10) }, 'folders'],
  companyFolderTemplates: (companyId, folderId, params) => [...keys.companyFolders(companyId), { folderId: parseInt(folderId, 10) }, 'templates', params],
  template: templateId => [...keys.all, { templateId: parseInt(templateId, 10) }]
};

export default keys;
